export default __webpack_public_path__ + "static/media/77.6019b2eb.jpeg";